import useToast from '~/hooks/useToast';

import { useSpaceMembershipFetcher } from './useSpaceMembershipFetcher';

/**
 * Surfaces the server toast after a space-membership submission settles.
 * The joined-spaces Set is refreshed by Remix's built-in layout revalidation
 * (see shouldRevalidate in routes/community.tsx), so this hook only handles
 * the toast — no .load() call, no ref guard needed.
 *
 * Mount once at the community layout.
 */
export const useSpaceMembershipToast = () => {
  const { fetcher } = useSpaceMembershipFetcher();
  useToast(fetcher.data?.toast);
};
